import urlModule from 'url';

import { isEmbeddedConfluenceInIframe_DO_NOT_USE } from '@atlassian/embedded-confluence-common/ccfe-entry-points';

// Keep these values aligned with @confluence/mobile-app-detection-common. They are duplicated here
// to avoid importing a product package into this @atlassian package.
// TODO: Extract these values to a shared Platform location so both packages use one source of truth.
const MOBILE_APP_PRESENTATION_MODE_VALUES: string[] = [
	'mobileAppWithEditing',
	'mobileAppWithCommenting',
	'mobileApp',
];

const isMobileAppPresentationMode = (value: string | string[] | undefined): boolean =>
	Array.isArray(value)
		? value.some((item) => MOBILE_APP_PRESENTATION_MODE_VALUES.includes(item))
		: Boolean(value && MOBILE_APP_PRESENTATION_MODE_VALUES.includes(value));

export const isEmbeddedConfluence_DO_NOT_USE = (location?: { search: string }): boolean => {
	if (!location) {
		location = window.location;
	}

	const { query } = urlModule.parse(location.search, true);

	return (
		query.embedded === 'true' ||
		Boolean(query.parentProduct) ||
		isMobileAppPresentationMode(query.presentationMode) ||
		isEmbeddedConfluenceInIframe_DO_NOT_USE()
	);
};
